import React from "react";

export class MojCasinoKategorije extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            kategorije: []
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.user !== this.props.user ||
            nextProps.categories !== this.props.categories ||
            nextState.kategorije !== this.state.kategorije
        );
    }

    static getDerivedStateFromProps(props, state) {
        if (props.categories) {
            let kategorije = [...props.categories];

            if (props.userChecked && props.user && props.user.favoriti.length) {
                kategorije.unshift({
                    id: 0,
                    name: 'Moje igre',
                    brojIgara: props.user.favoriti.length,
                    aktivno: true
                });
            }

            return { kategorije };
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        // Reinitialize lazy loading if categories change
        if (this.props.categories && this.props.categories !== prevProps.categories) {
            casino.utils.lazyImages.mountEventLazyLoadImages();
        }
    }

    render() {
        const { kategorije } = this.state;

        return (
            <div className="kategorija-line moj-casino-line">
                <h2 className="homepage-margin2 no-padding">Je li ti promaklo?</h2>

                {kategorije?.filter(x => x.aktivno).map(x => (
                    <div className="mojcasino-padding" key={x.id}>
                        <div className="game-item game-item2 game-item3">
                            <a
                                className="game-item-small relative"
                                href={`?lasttab=${x.id}`}
                            >
                                <div className="relative">
                                    <div className="relative">
                                        <div>
                                            <div className={`game-img game-img-icon kat kat${x.id}${x.id === 0 ? "" : " lazy"}`}>
                                                <div className="badge"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div style={{ width: '12px' }}></div>

                        <a
                            className="pobjednik-dana"
                            href={`?lasttab=${x.id}`}
                        >
                            <span className="pobjednik text-ellipsis">{x.name}</span>
                            <span className="iznos">{x.brojIgara}</span>
                        </a>
                    </div>
                ))}
            </div>
        );
    }
}
